import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Property } from '../../../../types/property';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

interface FinancialChartProps {
  properties: Property[];
}

export const FinancialChart: React.FC<FinancialChartProps> = ({ properties }) => {
  // Grouper les données par mois
  const monthlyData = properties.reduce((acc, property) => {
    const month = format(property.createdAt, 'MMMM yyyy', { locale: fr });
    
    if (!acc[month]) {
      acc[month] = {
        month,
        sales: 0,
        rent: 0,
        commissions: 0,
      };
    }

    if (property.status === 'sold') {
      acc[month].sales += property.price;
    } else if (property.status === 'rented') {
      acc[month].rent += property.price;
    }
    acc[month].commissions += property.commission;

    return acc;
  }, {} as Record<string, any>);

  const data = Object.values(monthlyData);

  return (
    <div className="h-[400px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip 
            formatter={(value: number) => `${(value / 1000000).toFixed(2)}M DA`}
          />
          <Legend />
          <Bar name="Ventes" dataKey="sales" fill="#0a8345" />
          <Bar name="Locations" dataKey="rent" fill="#4ade80" />
          <Bar name="Commissions" dataKey="commissions" fill="#86efac" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};